module.exports = __webpack_public_path__ + "static/twitter-promo-300afeccf49b16ba23d745e8d3ab96f3.png";